/**
 * Firebase Configuration
 * 
 * This module initializes Firebase services including:
 * - Firebase Authentication
 * - Firestore Database
 * - Google OAuth provider
 * 
 * @module firebase/config
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

/**
 * Firebase configuration object
 * 
 * These values should be replaced with your actual Firebase project configuration
 * from the Firebase console.
 * 
 * @type {Object}
 */
const firebaseConfig = {
  apiKey: "AIzaSyDKGywjyq-Nbv6Xb3yM-uuQ64pPoUBsGYE",
  authDomain: "acquaintancegame.firebaseapp.com",
  projectId: "acquaintancegame",
  storageBucket: "acquaintancegame.firebasestorage.app",
  messagingSenderId: "819713955634",
  appId: "1:819713955634:web:1b256a1ea135c2a87c292b"
};

/**
 * Initialize Firebase application
 * @type {FirebaseApp}
 */
const app = initializeApp(firebaseConfig);

/**
 * Firebase Authentication instance
 * @type {Auth}
 */
export const auth = getAuth(app);

/**
 * Firestore Database instance
 * @type {Firestore}
 */
export const db = getFirestore(app);

/**
 * Google OAuth provider
 * @type {GoogleAuthProvider}
 */
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

export default app; 